import { TableCell, TableRow, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"

export function FentraImportRow({ item }) {
    const hasError = Boolean(item?._error)

    return (
        <TableRow hover>
            <TableCell sx={{ width: 32, pr: 0 }}>
                <If value={hasError}>
                    <Tooltip title={item._error}>
                        <span>
                            <Iconify icon="mdi:alert-circle" sx={{ color: "error.main", verticalAlign: "middle" }} />
                        </span>
                    </Tooltip>
                </If>
            </TableCell>
            <TableCell sx={{ fontFamily: "monospace", fontSize: 12 }}>{item?.email}</TableCell>
            <TableCell>{item?.displayName}</TableCell>
            <TableCell>{item?.givenName}</TableCell>
            <TableCell>{item?.familyName}</TableCell>
            <TableCell>{item?.jobTitle}</TableCell>
        </TableRow>
    )
}
